import './App.css';
import './css/design-system.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SuperAdminLogin from './pages/superadmin/SuperAdminLogin';
import SuperAdminEmpresas from './pages/superadmin/SuperAdminEmpresas';
import SuperAdminFacturas from './pages/superadmin/SuperAdminFacturas';
import RegisterForm from './pages/forms/RegisterForm';
import LoginForm from './pages/forms/LoginForm';
// import FichajeForm from './pages/empleado/FichajeForm';
// import Home from './pages/Index';
import Layout from './layout/Layout';
import ProtectedRoute from './context/ProtectedRoute';
import SubscriptionRoute from './context/SubscriptionRoute';
import PublicRoute from './context/PublicRoute'; // <-- añadido
import { SubscriptionProvider } from './context/SubscriptionContext';

// 404 page
import NotFound from './layout/404';
import Unauthorized from './layout/Unauthorized';
import Informes from './pages/admin/Informes';
// Admin
import AdminLayout from './layout/AdminLayout';
import Empresa from './pages/admin/Empresa';
import Empleados from './pages/admin/Empleados';
import Fichajes from './pages/admin/Fichajes';
import FichajeFormAdmin from './pages/admin/FichajeFormAdmin';
import Subscribe from './components/Subscribe';
import IncidenciasAdmin from './pages/admin/Incidencias';
import DashboardAdmin from './pages/admin/DashboardAdmin';
// Empleado
import EmpleadoLayout from './layout/EmpleadoLayout';
import FichajeFormEmpleado from './pages/empleado/FichajeForm';
import EditarPerfil from './pages/empleado/EditarPerfil';
import IncidenciasEmpleado from './pages/empleado/IncidenciasEmpleado'; // <-- NUEVO
// import DashboardEmpleado from './pages/empleado/DashboardEmpleado';
import ResetPassword from './pages/forms/ResetPassword';
import ResetPasswordConfirm from './pages/forms/ResetPasswordConfirm';
import Docs from './pages/docs/Docs';

// Listados de informes
import ListadoHorasT from './pages/admin/ListadoHorasT';
import ListadoIncidenciasT from './pages/admin/ListadoIncidenciasT';

// Ausencias
import AusenciasEmpleado from './pages/empleado/AusenciasEmpleado';
import AusenciasAdmin    from './pages/admin/AusenciasAdmin';
import Ubicaciones      from './pages/admin/Ubicaciones';


// CSS
import './css/Login.css';
import Doc from './pages/admin/Doc';


function App() {
  return (
    <BrowserRouter>
      <SubscriptionProvider>
      <Routes>
        {/* Layout general */}
        <Route path="/" element={<Layout />}>
          <Route 
            index 
            element={
              <PublicRoute>
                <LoginForm />
              </PublicRoute>
            } 
          />

          <Route
            path="docs"
            element={<Docs />}
          />    

          <Route 
            path="reset-password" 
            element={
              <PublicRoute>
                <ResetPassword/>
              </PublicRoute>
            } 
          />

          <Route 
            path="reset-password/confirm" 
            element={
              <PublicRoute>
                <ResetPasswordConfirm />
              </PublicRoute>
            } 
          />

          <Route 
            path="register" 
            element={
              <PublicRoute>
                <RegisterForm />
              </PublicRoute>
            } 
          />
        </Route>


        {/* Panel de administrador */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<SubscriptionRoute role="admin"><DashboardAdmin /></SubscriptionRoute>} />
          <Route path="empresa" element={<SubscriptionRoute role="admin"><Empresa /></SubscriptionRoute>} />
          <Route path="empleados" element={<SubscriptionRoute role="admin"><Empleados /></SubscriptionRoute>} />
          <Route path="fichajes" element={<SubscriptionRoute role="admin"><Fichajes /></SubscriptionRoute>} />
          <Route path="fichar" element={<SubscriptionRoute role="admin"><FichajeFormAdmin /></SubscriptionRoute>} />
          <Route path="informes" element={<SubscriptionRoute role="admin"><Informes /></SubscriptionRoute>} />
          <Route path="informes/listadohoras" element={<SubscriptionRoute role="admin"><ListadoHorasT /></SubscriptionRoute>} />
          <Route path='informes/listadoincidencias' element={<SubscriptionRoute role="admin"><ListadoIncidenciasT /></SubscriptionRoute>} />
          <Route path="subscribe" element={<Subscribe />} />
          <Route path="incidencias" element={<SubscriptionRoute role="admin"><IncidenciasAdmin /></SubscriptionRoute>} />
          <Route path="ausencias"    element={<SubscriptionRoute role="admin"><AusenciasAdmin /></SubscriptionRoute>} />
          <Route path="ubicaciones"  element={<SubscriptionRoute role="admin"><Ubicaciones /></SubscriptionRoute>} />
          <Route path="doc"  element={<SubscriptionRoute role="admin"><Doc /></SubscriptionRoute>} />

        </Route>

        {/* Panel de empleado */}
        <Route
          path="/empleados"
          element={
            <ProtectedRoute allowedRoles={['empleado']}>
              <EmpleadoLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="fichar" replace />} />
          {/* <Route path='dashboard' element={<DashboardEmpleado />} /> */}
          <Route path="perfil" element={<SubscriptionRoute role="empleado"><EditarPerfil /></SubscriptionRoute>} />
          <Route path="fichar" element={<SubscriptionRoute role="empleado"><FichajeFormEmpleado /></SubscriptionRoute>} />
          <Route path="incidencias" element={<SubscriptionRoute role="empleado"><IncidenciasEmpleado /></SubscriptionRoute>} />
          <Route path="ausencias" element={<SubscriptionRoute role="empleado"><AusenciasEmpleado /></SubscriptionRoute>} />
        </Route>
        {/* Acceso denegado — destino de ProtectedRoute cuando el rol no coincide */}
        <Route path="unauthorized" element={<Unauthorized />} />

        {/* Superadmin: panel de facturas */}
        <Route path="superadmin/login"                        element={<SuperAdminLogin />} />
        <Route path="superadmin"                              element={<SuperAdminEmpresas />} />
        <Route path="superadmin/empresas/:empresaId/facturas" element={<SuperAdminFacturas />} />

        {/* 404 — debe ir al final para capturar cualquier ruta no definida */}
        <Route path="*" element={<NotFound />} />

      </Routes>
      </SubscriptionProvider>
    </BrowserRouter>
  );
}

export default App;
